import moment from 'moment';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  modules: {
  },
  state: {
    revenuePerMonthData: [],
    revenuePerMonthNotification: {
      data: {},
      status: 'loading',
      message: ''
    }
  },
  getters: {
    revenuePerMonthData: (state) => {
      return state.revenuePerMonthData;
    },
    revenuePerMonthNotification: (state) => {
      return state.revenuePerMonthNotification;
    },
    revenueByProjectPerMonth: (state) => {
      const revenueByProject = {};
      state.revenuePerMonthData.forEach((revenueData) => {
        const month = `${revenueData.year}${revenueData.month}`;
        revenueByProject[revenueData.project_id] = revenueByProject[revenueData.project_id] || {};
        revenueByProject[revenueData.project_id][month] = revenueByProject[revenueData.project_id][month] || 0;
        revenueByProject[revenueData.project_id][month] = parseFloat(revenueData.revenue);
      });
      return revenueByProject;
    }
  },
  mutations,
  actions
};
